// @owners { team: patients-team }
import { type NextAvailableDate } from '~shared/types';

/** Merged NAD payloads keyed by {@link getNextAvailableDateID} compound key string. */
export type NextAvailableDateMapping = Record<string, NextAvailableDate>;

/** NAD cache TTL; used by {@link isNextAvailableDateFresh} and derived freshness checks. */
export const NEXT_AVAILABLE_DATES_REFETCH_THRESHOLD_MS = 1000 * 60 * 5; // 5 minutes

/** True when `computedAt` is within {@link NEXT_AVAILABLE_DATES_REFETCH_THRESHOLD_MS} of `appTime`. */
export const isNextAvailableDateFresh = (computedAt: number, appTime: number): boolean =>
  appTime - computedAt < NEXT_AVAILABLE_DATES_REFETCH_THRESHOLD_MS;
